import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';

import { patch as patchStudentSlot } from 'actions/student-unique-slots';
import { invalidateItem as invalidateStudentSlots } from 'actions/student-slots';
import { store } from 'redux-rest-reducer';

import { Separator, Button, Text } from '@cuemath/comps';
import { Header, Checkbox } from 'semantic-ui-react';

import { Field, Head, ButtonWrapper, Message, SelectInput } from 'modules/form';

const WITH_TEACHER = 'WITH_TEACHER';

const AncorLink = styled.a`
  text-align: left;
  text-decoration: underline;
  color: blue;
  &:hover {
    color: blue;
  }
`;

const FormWrapper = styled.div`
  padding-left: 20px;
  text-align: center;
`;
const HeadWrapper = styled(Head)`
  border-bottom: 1px solid #333;
`;

class EditStudentSlotContainer extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      expireStudentSlot: PropTypes.func.isRequired,
      invalidateStudentSlots: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      autoEnter: null,
      studentPatch: store.patch(),
      activeCoursePatch: store.patch(),
      expireStudentSlot: false,
      errorText: null,
      message: null,
      courseSelected: null,
      courseEdited: false,
    };
  }

  static getDerivedStateFromProps(
    { studentUniqueSlots, actions, data },
    { studentPatch, activeCoursePatch, expireStudentSlot, courseEdited },
  ) {
    const newStudentPatch = store.patch(studentUniqueSlots, studentPatch.id);
    const coursePatch = store.patch(studentUniqueSlots, activeCoursePatch.id);
    const newState = {};

    if (coursePatch.resolved && courseEdited) {
      if (coursePatch.resolved.isPatched) {
        newState.message = 'Course Updated Successfully';
      } else if (coursePatch.resolved.isPatchingFailed) {
        newState.errorText = 'Course Updation Failed';
      }
      newState.courseEdited = false;
    }

    if (newStudentPatch.resolved && expireStudentSlot) {
      if (newStudentPatch.resolved.isPatched) {
        newState.message = 'Slot Expired Successfully';
        actions.invalidateStudentSlots(data.student_id);
      } else if (newStudentPatch.resolved.isPatchingFailed) {
        newState.errorText = store.getError(newStudentPatch.resolved).message;
      }
      newState.expireStudentSlot = false;
    }

    return newState;
  }

  onCourseSelect = selectedField => {
    this.setState({ courseEdited: true, courseSelected: selectedField });
  };

  getChoices = () => {
    const { courses = [] } = this.props;

    return courses
      .filter(({ access_type: accessType }) => accessType === WITH_TEACHER)
      .map(item => ({
        label: item.course_name,
        value: { id: item.id, courseId: item.course_id },
      }));
  };

  handleChangeCheckbox = (e, { checked }) => {
    this.setState({
      autoEnter: checked,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { actions, data } = this.props;
    const {
      courseEdited,
      activeCoursePatch: { id: slotId },
      courseSelected = {},
    } = this.state;
    const {
      value: { id = '', courseId = '' },
    } = courseSelected;

    if (courseEdited && id && courseId) {
      actions.patchStudentSlot(slotId, data.id, {
        action: 'student_slot_course_update',
        action_data: {
          student_course_id: id,
          course_id: courseId,
        },
      });
    }
  };

  onStudentClick = () => {
    const { actions, data } = this.props;
    const {
      studentPatch: { id },
    } = this.state;

    this.setState({ expireStudentSlot: true }, () => {
      actions.patchStudentSlot(id, data.id, {
        action: 'expire',
      });
    });
  };

  componentDidMount() {
    const { courses = [], data = {} } = this.props;
    const activeCourse = courses.find(({ id }) => id === data.student_course_id);

    if (activeCourse) {
      this.setState({
        courseSelected: {
          label: activeCourse.course_name,
          value: { id: activeCourse.id, courseId: activeCourse.course_id },
        },
      });
    }
  }

  render() {
    const { autoEnter, errorText, message, courseSelected } = this.state;
    return (
      <React.Fragment>
        <form onSubmit={this.handleSubmit}>
          <HeadWrapper>
            <Text size="xlarge" align="center">
              Edit
            </Text>
          </HeadWrapper>

          <FormWrapper>
            {message && <Message>{message}</Message>}
            {errorText && <Message error>{errorText}</Message>}
            <Separator transparent height="25" />
            <Text size="medium" weight="semibold">
              Student Course
            </Text>
            <SelectInput
              options={this.getChoices()}
              onChange={this.onCourseSelect}
              value={courseSelected}
            />
            <Separator transparent height="25" />
            <Field key={'autoEnter'} label={'Auto-Enter'} control="checkbox">
              <Checkbox
                name={'autoEnter'}
                checked={autoEnter}
                onChange={this.handleChangeCheckbox}
                label={'Auto-Enter'}
                disabled
              />
            </Field>
            <Separator height={30} transparent />

            <div>
              <Header as="h6" floated="left">
                <AncorLink href="#" onClick={() => this.onStudentClick()}>
                  Expire Student Slot
                </AncorLink>
              </Header>
              <Header floated="right">
                <ButtonWrapper flexDirection="row-reverse">
                  <Button label="Submit" />
                </ButtonWrapper>
              </Header>
              <Separator transparent height="30" />
            </div>
          </FormWrapper>
        </form>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ studentUniqueSlots }) => ({
    studentUniqueSlots,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        patchStudentSlot,
        invalidateStudentSlots,
      },
      dispatch,
    ),
  }),
)(EditStudentSlotContainer);
